import { types } from 'mobx-state-tree';

import { level, utils } from 'lib';

const FinanceModel = types
  .model('FinanceModel', {
    // 用户柠檬
    coin_count: 0,
    // 总花费的柠檬
    coin_spend_total: 0,
    // 主播维C
    bean_count: 0,
    // 主播总维C
    bean_count_total: 0,
    // 主播总收益流水
    benefit_total: 0,
    // 收益余额 单位：分
    profit: 0,
    // 总收益
    profit_total: 0,
  })
  .views((self) => {
    return {
      get richData() {
        return level.getRichLevel(self.coin_spend_total);
      },
      get coinData() {
        return level.getCoinLevel(self.coin_spend_total);
      },
      get starData() {
        return level.getStarLevel(self.benefit_total);
      },
      get benefit_total_text() {
        return utils.getCny(self.benefit_total);
      },
      get profit_text() {
        return utils.getCny(self.profit);
      },
    };
  });

export default FinanceModel;
